export default {
  title: 'Importing ',
  history: 'History',
  date: 'Date',
  doneBy: 'Done by',
  status: 'Status',
  errorReport: 'Error report',
  importing: 'Importing',
  error: 'Error',
  completed: 'Completed',
  importHistory: 'Import History',
  of: 'of',
  fileNotSupported: 'File not supported. Only xlsx files are allowed',
  dragExcelHere: 'Drag the excel here or click to select',
  importError: 'An error occurred during import!',
  whatToDoNow: 'What to do now?',
  downloadIncorrectData: 'Download the spreadsheet with incorrect data',
  fixDataInNewSheet: 'Fix the data in the new spreadsheet',
  doNewUpload: 'Do a new upload',
  downloadNewSheet: 'Download new spreadsheet',
  importCompletedSuccessfully: 'Import completed successfully!',
  importInstructions: 'Import instructions',
  importInstructionsDescription:
    'Btime imports are done through predefined spreadsheet templates. For a data import to be accepted by our system, download the template spreadsheet below and import one with the same structure.',
  downloadTemplate: 'Download template',
  notDownloadedWarning:
    "You have not yet downloaded the spreadsheet with incorrect data. Are you sure you don't want to do that first?"
}
